module.exports = class Processor {
  constructor () {
    this.video = document.getElementById('video')
    this.canvas = document.getElementById('videoOverlay')
    this.context = this.canvas ? this.canvas.getContext('2d') : undefined
    this.blinder = require('color-blind')

    this.video.addEventListener(
      'play',
      () => {
        requestAnimationFrame(this.updateCanvas.bind(this))
      },
      false
    )

    this.setCanvasOverlay()
  }

  setCanvasOverlay () {}

  updateCanvas () {
    if (this.video.ended || this.video.paused || !this.canvas) {
      return
    }

    this.context.drawImage(
      this.video,
      0,
      0,
      this.video.width,
      this.video.height
    )

    this.transformImage()

    requestAnimationFrame(this.updateCanvas.bind(this))
  }

  transformImage () {}
}
